import { STEPS_ALLOWING_MULTIPLES } from '../constants/Steps';

export const getStepKey = (id, cardType) => {
  const needsType = STEPS_ALLOWING_MULTIPLES.includes(id) && !!cardType;

  return needsType ? `${id}-${cardType}` : id;
};
